import {Injectable} from '@angular/core';
import {Observable, Subject, Subscription, timer} from 'rxjs';
import {StateService} from './state.service';

@Injectable({
    providedIn: 'root'
})
export class SessionService {

    private sessionExpiration: Subject<void> = new Subject<void>();
    private sessionTimerSub: Subscription;

    constructor(private state: StateService) {
    }

    /** Returns an observable that will emit every time the user session expires.
     */
    sessionExpired(): Observable<void> {
        return this.sessionExpiration.asObservable();
    }

    /** Starts or restarts the session timer so after the max idle time expires, the session expiration observable will emit.
     * If session is already started, this will reset it to extend its expiration time to start from the current time.
     */
    restartSession() {
        const maxIdle = this.state.get("maxIdle");
        if (maxIdle) {
            this.clearSession();
            this.sessionTimerSub = timer(maxIdle*1000).subscribe(()=> {
                this.sessionExpiration.next();
            });
        }
    }

    /** Stops and clears session timer so session expiration observable will never emit (unless restarted)
     */
    clearSession() {
        if (this.sessionTimerSub) {
            this.sessionTimerSub.unsubscribe();
            this.sessionTimerSub = undefined;
        }
    }

}
